<div class="table-filters-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Filters</h2>
    <button mat-icon-button type="button" (click)="dialogRef.close()" aria-label="Close filters dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <mat-accordion multi>
      @for (config of data.configs; track config.columnId) {
        <mat-expansion-panel [(expanded)]="panelExpanded[config.columnId]">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ config.columnLabel }}</mat-panel-title>
            @if (isColumnActive(config.columnId)) {
              <mat-panel-description>
                <span class="active-badge">Active</span>
              </mat-panel-description>
            }
          </mat-expansion-panel-header>

          <app-column-filter-editor
            [config]="config"
            [criterion]="localState[config.columnId]"
            (criterionChange)="onColumnCriterionChange(config.columnId, $event)"
          ></app-column-filter-editor>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button type="button" color="primary" (click)="clearAll()" [disabled]="activeFilterCount === 0">
      Clear all
    </button>
    <button mat-flat-button type="button" color="primary" (click)="apply()">Apply</button>
  </mat-dialog-actions>
</div>
